// extracted by mini-css-extract-plugin
export default {"selectWrapper":"select_selectWrapper__UJ4kw","label":"select_label__SI0c2","selectRoot":"select_selectRoot__LGAGw","menuItem":"select_menuItem__NmTUZ"};